import { Component, computed, inject, model, signal } from '@angular/core';
import { StationLongDto } from '@api/rest';
import { StationType } from '@app/shared/enums/station-type.enum';
import { StationFacade } from '@app/station/station.facade';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AsyncPipe, CommonModule } from '@angular/common';
import { GoogleMapComponent } from '../google-map/google-map.component';
import { ContactDetailComponent } from "../contact-detail/contact-detail.component";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    imports: [GoogleMapComponent, AsyncPipe, CommonModule, ContactDetailComponent, TranslatePipe]
})
export class ContactComponent {
  private readonly facade = inject(StationFacade);
  private readonly allStationsSignal = this.facade.allStationsSignal;

  protected readonly translate = inject(TranslateService);
  protected readonly contactStations$: Observable<StationLongDto[]> = this.facade.getStationsByType(StationType.CONTACT);
  protected readonly selected = model<StationLongDto | undefined>(undefined);
  protected readonly selectedCategory = signal<string | undefined>('69ef1d316af5030356445911'); // TODO: Currently hardcoded, find better way.
  protected displayType: 'list' | 'map' = 'map';


  protected setSelectedContact(contact: StationLongDto) {
    this.selected.set(contact);
    this.displayType = 'map';
  }

  protected readonly contactCategories = computed(() =>
    this.allStationsSignal()?.filter(
      station => station.type === StationType.CONTACT_CATEGORY
    )
  );

protected readonly filteredContacts = computed(() => {
  const selected = this.selectedCategory();
  const allStations = this.allStationsSignal();

    if (selected !== undefined) {
      const categoryStation = allStations?.find(station => String(station.id) === selected);
      const subIds = categoryStation?.substation_order ?? [];

      return allStations?.filter(station =>
        station.type === StationType.CONTACT && subIds.includes(station.id)
      );
    }

    return allStations?.filter(station => station.type === StationType.CONTACT);
  });

  protected onSelectContactCategory(event: Event) {
    const value: string = (event.target as any).value;
    if (value === 'undefined') {
      this.selectedCategory.set(undefined);
    } else if (value) {
      this.selectedCategory.set(value);
    }

    this.selected.set(undefined);
  }

}
